import React, { useContext } from "react";
import { TableContainer, Paper } from "@material-ui/core";

import {
  STOCKPILES_TABLE_COLUMNS_NUMBER,
  STOCKPILES_OUTPUT_PARAMS,
} from "../../constants";
import { MatchContext } from "../../context";
import EmptyTable from "./components/empty-table.component";
import FilledTable from "./components/filled-table.component";
import useStyles from "../tables-container/styles";

export default function OutputTable(): JSX.Element {
  const { state } = useContext(MatchContext);
  const classes = useStyles();

  return (
    <div className="stockpiles-table">
      <TableContainer
        component={Paper}
        className={!state.hideMatchingTable && classes.container}
      >
        {!state.showStockpileData ? (
          <EmptyTable
            columnsNumber={STOCKPILES_TABLE_COLUMNS_NUMBER}
            stockpilesTableFeatures={STOCKPILES_OUTPUT_PARAMS}
          />
        ) : (
          <FilledTable stockpilesTableFeatures={STOCKPILES_OUTPUT_PARAMS} />
        )}
      </TableContainer>
    </div>
  );
}
